import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { MatriculaSecretaria } from 'src/app/core/matricula-secretaria';
import { Unidade } from 'src/app/core/unidade';
import { MatriculaSecretariaService } from 'src/app/services/matricula-secretaria/matricula-secretaria.service';

@Component({
  selector: 'combo-matricula-secretaria',
  templateUrl: './combo-matricula-secretaria.component.html',
  styleUrls: ['./combo-matricula-secretaria.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm },
    { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }
  ]
})
export class ComboMatriculaSecretariaComponent implements OnChanges {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() unidade: Unidade;

  @Output() valorChange = new EventEmitter<MatriculaSecretaria>();

  dados: MatriculaSecretaria[] = [];
  data = Date.now();

  constructor(private matriculaSecretariaService: MatriculaSecretariaService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unidade']) {
      this.carregarDados();
      return;
    }

    if (changes['selecionado']) {
      this.preencherCombo();
    }
  }

  onValorChange(registro: MatriculaSecretaria): void {
    this.valorChange.emit(registro);
  }

  private carregarDados(): void {
    const idUnidade = this.unidade ? this.unidade.idUnidade : null;

    this.matriculaSecretariaService.getAllBy(idUnidade).subscribe((matriculas: MatriculaSecretaria[]) => {
      this.dados = matriculas || [];
      this.dados.sort((a, b) => a.descricao.localeCompare(b.descricao));
      this.preencherCombo();
    });
  }

  private preencherCombo(): void {
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });

      if (!this.selecionado) {
        this.valorChange.emit(null);
      }
    }
  }
}
